import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_CONVENTIONAL_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<BMO_CONVENTIONAL_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_CONVENTIONAL_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_CONVENTIONAL_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<BMO_CONVENTIONAL_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: BMO_CONVENTIONAL_REQUEST_FOR_FUNDS = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page1[0]",
	// "2":"topmostSubform[0].Page1[0].FAX_NO[0]",
	// "3":"topmostSubform[0].Page1[0].NOTARY_SIGNATURE[0]",
	lawyerName: 'topmostSubform[0].Page1[0].NOTARY_NAME[0]',
	branchAddress: 'topmostSubform[0].Page1[0].BMO_BRANCH_ADDRESS[0]',
	account: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_NUMBER[0]',
	transit: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_TRANSIT[0]',
	bank: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_BANK[0]',
	totalMortgageFunds:
		'topmostSubform[0].Page1[0].TOTAL_MORTGAGE_FUNDS_REQUESTED[0]',
	correctTrustAccountDetails:
		'topmostSubform[0].Page1[0].TRUST_ACCOUNT_INFO_CORRECT[0]',
	fundingDate: 'topmostSubform[0].Page1[0].CLOSING_DATE[0]',
	borrowers: 'topmostSubform[0].Page1[0].BORROWER[0]',
	reference: 'topmostSubform[0].Page1[0].REFERENCE_NUMBER[0]',
	lawyerNumber: 'topmostSubform[0].Page1[0].NOTARY_ID_NUMBER[0]',
	mortgageLoanNumber: 'topmostSubform[0].Page1[0].MORTGAGE_NUMBER[0]',
	// "16":"topmostSubform[0].Page1[0].BARCODE_FINAL_REPORT[0]"
};
export interface BMO_CONVENTIONAL_REQUEST_FOR_FUNDS {
	lawyerNumber: string;
	mortgageLoanNumber: string;
	reference: string;
	borrowers: string;
	fundingDate: string;
	totalMortgageFunds: string;
	correctTrustAccountDetails: string;
	bank: string;
	transit: string;
	account: string;
	branchAddress: string;
	lawyerName: string;
}
